export const LIST_CONTAINER_WIDTH = 848
export const LIST_WIDTH = 800
export const GRID_COLS = 12
export const GRID_ROW_HEIGHT = 63


// WEBPACK FOOTER //
// ./constants/ScriptLogTemplateBuilder.js